import '../../../../assets/css/screens/customer/dashboard/paymentsuccesspage/PaymentSuccessPage.css';
import AppNavbar from '../../../../components/customer/dashboard/apphome/appnavbar/AppNavbar';

import { useEffect, useState, useContext } from "react";
import axios from "axios";
import AppContext from "../../../../context/AppContext";
import { useNavigate, useLocation } from "react-router-dom";
import { CheckCircle2, ArrowLeft, Download, Home } from "lucide-react";
export default function WorkerPaymentSuccess() {
    const navigate = useNavigate();
    const { baseUrl } = useContext(AppContext);
    const location = useLocation();
    const [show, setShow] = useState(false);
    const [ripple, setRipple] = useState(false);
    const [paymentData, setPaymentData] = useState(null);
    const [loading, setLoading] = useState(true);



    useEffect(() => {
        // slight delay so CSS animation triggers cleanly
        const t1 = setTimeout(() => setShow(true), 80);
        const t2 = setTimeout(() => setRipple(true), 400);
        return () => { clearTimeout(t1); clearTimeout(t2); };
    }, []);
    useEffect(() => {

        const params = new URLSearchParams(window.location.search);
        const session_id = params.get("session_id");

        if (!session_id) return;

        const loadPayment = async () => {
            try {
                setLoading(true);

                // Payment success
                await axios.get(
                    `${baseUrl}/subscription/success?session_id=${session_id}`,
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem("authToken")}`
                        }
                    }
                );

                // Payment details
                const res = await axios.get(
                    `${baseUrl}/provider/subscription/details?session_id=${session_id}`,
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem("authToken")}`
                        }
                    }
                );

                if (res.data.success) {
                    setPaymentData(res.data.data);
                }
            }
            catch (err) {

                if (err.response) 
                    {
                    console.log(err.response.data);
                } else {
                    console.log(err.message);
                }

            }
            finally {
                setLoading(false);
            }
        };

        loadPayment();

    }, [baseUrl]);
    if (loading) {
        return (
            <div className="ps-loading">
                <div className="ps-loader"></div>
                <h3>Loading payment details...</h3>
            </div>
        );
    }
    return (
        <div className={`ps-page${show ? " ps-page--show" : ""}`}>

            {/* ── background blobs ── */}
            <div className="ps-blob ps-blob--1" />
            <div className="ps-blob ps-blob--2" />

            {/* ── back button ── */}
            <button className="ps-back" onClick={() => navigate('/worker-dashboard')}>
                <ArrowLeft size={18} />
            </button>

            {/* ── SUCCESS ICON ── */}
            <div className="ps-icon-wrap">
                {/* ripple rings */}
                {ripple && (
                    <>
                        <span className="ps-ring ps-ring--1" />
                        <span className="ps-ring ps-ring--2" />
                        <span className="ps-ring ps-ring--3" />
                    </>
                )}
                <div className="ps-icon-circle">
                    <CheckCircle2 size={52} color="#fff" strokeWidth={1.8} />
                </div>
            </div>

            {/* ── heading ── */}
            <div className="ps-heading">
                <h1 className="ps-title">Payment Successful!</h1>
                <p className="ps-sub">Your transaction has been completed.</p>
            </div>

            {/* ── amount ── */}
            <div className="ps-amount-wrap">
                <span className="ps-amount">{paymentData?.amount}$</span>
            </div>

            {/* ── actions ── */}
            <div className="ps-actions">
                <button
                    className="ps-btn ps-btn--primary"
                    onClick={() => navigate("/worker-dashboard")}
                >
                    <Home size={18} />
                    <span>Go to Home</span>
                </button>

                <button
                    className="ps-btn ps-btn--ghost"
                    onClick={() => window.print()}
                >
                    <Download size={18} />
                    <span>Save Receipt</span>
                </button>
            </div>

            {/* ── powered by stripe ── */}
            <p className="ps-stripe-tag">Secured & powered by <strong>Stripe</strong></p>
        </div>
    );
}